import raf from '@/assets/countries/1200px-RAF_roundel.svg.png';
import luft from '@/assets/countries/1920px-Balkenkreuz_underwing.svg.png';
import fr from '@/assets/countries/1920px-Roundel_of_France.svg.png';
import it from '@/assets/countries/1200px-Roundel_of_Italy.svg.png';
import jp from '@/assets/countries/1920px-Roundel_of_Japan_(1943).svg.png';
import ru from '@/assets/countries/1920px-Roundel_of_the_Soviet_Union_(1945–1991).svg.png';
import us from '@/assets/countries/USAAC_Roundel_1919-1941.svg.png';
import Country from '@/models/Country';

const Countries = [
  new Country({
    name: 'France',
    logo: fr,
  }),
  new Country({
    name: 'Germany',
    logo: luft,
  }),
  new Country({
    name: 'Great Britain',
    logo: raf,
  }),
  new Country({
    name: 'Italy',
    logo: it,
  }),
  new Country({
    name: 'Japan',
    logo: jp,
  }),
  new Country({
    name: 'Russia',
    logo: ru,
  }),
  new Country({
    name: 'US',
    logo: us,
  }),
];
export default Countries;
